/**
 * @author Pawan Sadvale
 * @email Pawan.Sadvale@ul.com
 * @create date 2020-02-26 15:07:41
 * @modify date 2020-02-26 15:07:41
 * @desc [description]
 */
import axios from 'axios';

/**
 * getAccounts get api
 * to get accounts list */
export async function getAccounts(payload) {
  let result = [];
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/data/account`, payload)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      result = err;
      console.log('get team_member java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * addTeamMember post api
 * to add new Team Member */
export async function deactivateAccount1(data) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/deactivate/account`;
  let result = '';
  await axios
    .delete(url, data)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response;
        console.log('reppp', response);
      }
    })
    .catch((err) => {
      console.log('deactivate self account java api error', err);
    });
  return result;
}

export async function activateAccount(data) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/activate/account`;
  let result = '';
  await axios
    .put(url, data)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('deactivate self account java api error', err);
    });
  return result;
}
export async function deactivateAccount(formData) {
  const url = `${process.env.VUE_APP_JAVA_API_URL}/activity/tracker/deactivate/account`;
  let result = '';
  await axios
    .delete(url, { data: formData })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
        console.log('reppp', response);
      }
    })
    .catch((err) => {
      console.log('deactivate self account java api error', err);
    });
  return result;
}
